module.exports = __webpack_public_path__ + "img/palm-x6-plus-3.6e94fc9c.png";